<template>
  <div v-if="countriesOrBasins.length > 1" class="country-basin-ct">
    <div v-if="commodity" @click="select(null)" title="Show for all countries" class="country-basin-item" :class="{active: isSelected(null)}">
      All
    </div>
    <div v-for="(countryOrBasin, i) of countriesOrBasins" :key="i" @click="select(countryOrBasin)" :title="'Show only for ' + countryOrBasin.name" :class="{active: isSelected(countryOrBasin)}" class="country-basin-item">
      {{countryOrBasin.name}}
    </div>
  </div>
</template>

<script>
import { scenarioCountryCrops, getCountry } from "@/services/entity-model.js";
import { assessment } from "@/services/assessment-model.js";
import * as _ from 'lodash';

export default {
    name: "CountryOrBasinSelector",
    data() {
        return {
            assessment: assessment,
            scenarioCountryCrops: scenarioCountryCrops
        }
    },
    computed: {
        commodity() {
            return assessment.assessmentType.name == "commodity";
        },
        objectPropertyID() {
            return assessment.assessmentType.idPropertyName;
        },
        countriesOrBasins() {
            let countriesOrBasins = []
            if (this.commodity) {
                const countryIdsHash = {};
                this.scenarioCountryCrops.forEach(scenarioCountryCrop => countryIdsHash[scenarioCountryCrop.countryId] = true);
                countriesOrBasins = Object.keys(countryIdsHash).map(countryId => getCountry(countryId));
            } else {
                countriesOrBasins = assessment.countriesOrBasins;
            }
            return _.orderBy(countriesOrBasins, ["name"]);
        },
    },
    methods: {
        select(countryOrBasin) {
            if (this.isSelected(countryOrBasin)) {
                return;
            }

            if (this.commodity) {
                if (countryOrBasin == null) {
                    this.assessment.setCountriesOrBasins([]);
                } else {
                    this.assessment.setCountriesOrBasins([countryOrBasin]);
                }
            } else {
                const otherCountriesOrBasins = _.filter(assessment.countriesOrBasins, cb => cb[this.objectPropertyID] != countryOrBasin[this.objectPropertyID]);
                this.assessment.setCountriesOrBasins([countryOrBasin, ...otherCountriesOrBasins]);
            }
        },
        isSelected(countryOrBasin) {
            if ((countryOrBasin == null) || (assessment.countriesOrBasins.length == 0)) {
                return (countryOrBasin == null) && (assessment.countriesOrBasins.length == 0);
            }
            return countryOrBasin[this.objectPropertyID] == assessment.countriesOrBasins[0][this.objectPropertyID];
        }
    }
}
</script>

<style lang="scss" scoped>
.country-basin-ct {
    display: flex;
    margin-bottom: 10px;
}

.country-basin-item {
    cursor: pointer;
    background-color: white;
    padding: 5px 10px;
    border: 1px solid #edebe5;
    border-radius: 5px;
    margin-right: 10px;
    &.active {
        background-color: #009bd1;
        color: white;
        border-color: #009bd1;
    }
}
</style>
